import { useState } from "react";
import BuscarCotizacion from "./BuscarCotizacion";
import { Button } from "react-bootstrap";



export default function BuscarCotizacionButton({ add }: { add: (d: any) => void }) {
    const [o, s] = useState(false);
    return <>
        <BuscarCotizacion add={add} open={o} close={() => s(false)} />
        <Button onClick={() => s(true)}
            data-class="toolbody" data-html="true"
            data-tip="CARGAR COTIZACION" variant="primary">
            <span className="fa fa fa-calculator" />
        </Button>
    </>
}